import React, { Component } from 'react';
import GetOnlyviewUbication from './getOnlyviewUbication';
import LocationSearchInput from './locationSearchInput';
import { geolocated } from "react-geolocated";
class getUbicacionStep extends Component {
  constructor(){
    super();
    this.state = {
        lon:0,
        lat:0,
        sw_red:true,
        new_lon:0,
        new_lat:0
    }
  }

  get_go_to =(modulo_modal,lat,lng,name)=>{
    this.setState({
    new_lat:lat,new_lon:lng
    })
  }
  get_goto =()=>{

  }
  componentWillUnmount () {
    clearInterval(this.timer)
  }
  tick () {
    let latitude =0
    //let longitude =0
    try {
      latitude =   this.props.coords.latitude
      //longitude =  this.props.coords.longitude
    } catch(e) {
      //latitude = -0.25692696536573
      //longitude = -78.526462827442
    }
    if(Number(latitude)===0){
      console.log("no hay red")
      this.setState({
        sw_red:false
      })
    }
    clearInterval(this.timer)
  }
  startTimer () {
    clearInterval(this.timer)
    this.timer = setInterval(this.tick.bind(this), 3000)
  }
  componentDidMount() {
    if ("geolocation" in navigator) {
    //  console.log("Available");
    } else {
      //console.log("Not Available");
    }
    if (navigator.geolocation) {
      //console.log("_________");
      navigator.geolocation.watchPosition(function(position) {
        //console.log("Latitude is :", position.coords.latitude);
      //  console.log("Longitude  is :", position.coords.longitude);
      });
    }
    this.startTimer ()
  }

  render() {
  const sw_red = this.state.sw_red
  const new_lon = Number(this.state.new_lon)
  const new_lat = Number(this.state.new_lat)
//  const modulo_modal = this.state.modulo_modal

  let dir_modulo_modal
  if(sw_red===false&&Number(new_lon)===0){
    dir_modulo_modal = <React.Fragment><LocationSearchInput get_go_to={this.get_go_to} get_go_to_step={this.get_goto} /></React.Fragment>

  }else{
    let latitude =0
    let longitude =0
    if(Number(new_lon)!==0){
      latitude = new_lat
      longitude = new_lon
    }else{
      try {
        latitude =   this.props.coords.latitude
        longitude =  this.props.coords.longitude
      } catch(e) {
        //latitude = -0.25692696536573
        //longitude = -78.526462827442
      }
    }
    dir_modulo_modal =<React.Fragment>
    {(!this.props.isGeolocationAvailable) ? (
          <div>Your browser does not support Geolocation</div>
      ) : !this.props.isGeolocationEnabled ? (
          <div>Geolocation is not enabled</div>
      ) : this.props.coords ? (''
      ) : (
          <div>Getting the location data&hellip; </div>
      )
    }

    <div className="grid-container_getpedido">
      <div className="lbl_title_final_getpedido">Ubicación Actual</div>
      <div className="lbl_icon_final_getpedido"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
    </div>
    <div className="grid-container_buy_getviewpedido_ubicacion">
      <div className="lbl_icon_final_buy_getviewpedido_ubicacion">
      {(Number(latitude)>0||Number(latitude)<0)?
        <GetOnlyviewUbication className="pruebas" lat={latitude}  lon={longitude} edit={true} />
      :''}
      </div>
    </div>
    <button style={{"width":"100%"}} className="button-global" onClick={ () => this.props.get_ubicacion()} >
    CONTINUAR
    </button>
    </React.Fragment>
  }




   return (
      <React.Fragment>
      {dir_modulo_modal}
      </React.Fragment>
    );
  }


}
export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
})(getUbicacionStep);
//export default getUbicacionStep;
